var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAsbclogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 729.53 106.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5dbb5a;}.cls-2{fill:#44b866;}.cls-3{fill:#29b574;}.cls-4{fill:#76c04c;}.cls-5{fill:#8cc540;}.cls-6{fill:#3a3a3c;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.97 6.99 80.45 21.11 53.97 27.28 53.97 6.99"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "84.57 20.67 80.33 9.36 95.92 25.45 84.57 20.67"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.97 0 68.95 3.72 53.97 3.72 53.97 0"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "86.25 23.86 99.5 29.44 99.51 48.09 86.25 23.86"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "57.02 6.02 76.64 6.02 81.54 19.1 57.02 6.02"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "55.08 29.37 82.17 23.05 76.21 50.53 55.08 29.37"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "78.3 51.68 84.14 24.76 98.87 51.68 78.3 51.68"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.97 51.68 53.97 31.49 74.13 51.68 53.97 51.68"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "101.7 51.68 105.62 51.68 101.7 36.99 101.7 51.68"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "51.66 6.99 25.17 21.11 51.66 27.28 51.66 6.99"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "21.05 20.67 25.29 9.36 9.7 25.45 21.05 20.67"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "51.66 0 36.67 3.72 51.66 3.72 51.66 0"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "19.37 23.86 6.12 29.44 6.12 48.09 19.37 23.86"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "48.6 6.02 28.98 6.02 24.08 19.1 48.6 6.02"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "50.54 29.37 23.45 23.05 29.41 50.53 50.54 29.37"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "27.32 51.68 21.48 24.76 6.75 51.68 27.32 51.68"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "51.66 51.68 51.66 31.49 31.5 51.68 51.66 51.68"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "3.92 51.68 0 51.68 3.92 36.99 3.92 51.68"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "53.97 98.67 80.45 84.54 53.97 78.37 53.97 98.67"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "84.57 84.98 80.33 96.29 95.92 80.2 84.57 84.98"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "53.97 105.65 68.95 101.93 53.97 101.93 53.97 105.65"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "86.25 81.8 99.5 76.21 99.51 57.56 86.25 81.8"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "57.02 99.63 76.64 99.63 81.54 86.55 57.02 99.63"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "55.08 76.28 82.17 82.6 76.21 55.12 55.08 76.28"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "78.3 53.97 84.14 80.89 98.87 53.97 78.3 53.97"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.97 53.97 53.97 74.16 74.13 53.97 53.97 53.97"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "101.7 53.97 105.62 53.97 101.7 68.66 101.7 53.97"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "51.66 98.67 25.17 84.54 51.66 78.37 51.66 98.67"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "21.05 84.98 25.29 96.29 9.7 80.2 21.05 84.98"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "51.66 105.65 36.67 101.93 51.66 101.93 51.66 105.65"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "19.37 81.8 6.12 76.21 6.12 57.56 19.37 81.8"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.6 99.63 28.98 99.63 24.08 86.55 48.6 99.63"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.54 76.28 23.45 82.6 29.41 55.12 50.54 76.28"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "27.32 53.97 21.48 80.89 6.75 53.97 27.32 53.97"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "51.66 53.97 51.66 74.16 31.5 53.97 51.66 53.97"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "3.92 53.97 0 53.97 3.92 68.66 3.92 53.97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M195.56,72.5H178.89l-3.42,9.38H167l15.74-41H192l15.63,41H199Zm-14-7.29h11.34L187.22,49.7Z",
    transform: "translate(-46.1 -33.61)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M213.38,81.88V53.4h7.35v3.47c1.56-2.78,5.21-4.28,8.33-4.28,3.88,0,7,1.68,8.45,4.75a9.89,9.89,0,0,1,9-4.75c5.27,0,10.3,3.18,10.3,10.82V81.88h-7.46V65c0-3.07-1.51-5.39-5-5.39-3.3,0-5.26,2.55-5.26,5.62V81.88h-7.64V65c0-3.07-1.57-5.39-5-5.39s-5.32,2.49-5.32,5.62V81.88Z",
    transform: "translate(-46.1 -33.61)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.34,73.71c-1.45,4.92-6,9-13,9-7.81,0-14.7-5.61-14.7-15.22,0-9.08,6.72-15,14-15,8.79,0,14.06,5.62,14.06,14.76,0,1.1-.11,2.26-.11,2.37H271.25a6.94,6.94,0,0,0,7.18,6.49c3.59,0,5.56-1.8,6.48-4.34Zm-7.18-9.31c-.12-2.84-2-5.62-6.37-5.62a6.16,6.16,0,0,0-6.36,5.62Z",
    transform: "translate(-46.1 -33.61)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.34,61a11.87,11.87,0,0,0-2.32-.23c-3.93,0-7.35,1.91-7.35,8v13H299V53.4h7.47v4.23c1.74-3.77,5.67-4.46,8.1-4.46.64,0,1.22.06,1.8.11Z",
    transform: "translate(-46.1 -33.61)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M326.75,39.28a4.75,4.75,0,1,1-4.74,4.8A4.74,4.74,0,0,1,326.75,39.28Zm-3.82,42.6V53.4h7.7V81.88Z",
    transform: "translate(-46.1 -33.61)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M345.56,67.64c0,5.15,3.36,8,7.3,8a6.52,6.52,0,0,0,6.54-4.8l6.77,2.26c-1.28,4.74-5.73,9.6-13.31,9.6a14.72,14.72,0,0,1-15-15.1c0-8.8,6.48-15.11,14.75-15.11,7.76,0,12.16,4.81,13.37,9.61l-6.88,2.31a6.22,6.22,0,0,0-6.31-4.8C348.86,59.65,345.56,62.49,345.56,67.64Z",
    transform: "translate(-46.1 -33.61)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M379.65,65.5l7-1c1.62-.23,2.14-1,2.14-2,0-2-1.56-3.7-4.8-3.7s-5.21,2.14-5.44,4.62l-6.83-1.44c.46-4.46,4.57-9.38,12.21-9.38,9,0,12.39,5.1,12.39,10.82v14a31,31,0,0,0,.35,4.52H389.6a19.84,19.84,0,0,1-.28-3.42,9.53,9.53,0,0,1-8.4,4.23c-6.07,0-9.78-4.11-9.78-8.57C371.14,69,374.9,66.19,379.65,65.5Zm9.14,4.86V69.08l-6.42,1c-2,.29-3.53,1.39-3.53,3.59,0,1.68,1.22,3.3,3.7,3.3C385.79,77,388.79,75.39,388.79,70.36Z",
    transform: "translate(-46.1 -33.61)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M412.93,81.88h-7.7V53.4h7.47v3.53a9.45,9.45,0,0,1,8.21-4.28c7.06,0,10.31,5,10.31,11.28V81.88h-7.7V65.27c0-3.19-1.56-5.68-5.27-5.68-3.36,0-5.32,2.61-5.32,5.91Z",
    transform: "translate(-46.1 -33.61)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M479,52.82c-.4-2.26-2.25-5.79-7.46-5.79-3.88,0-6.43,2.49-6.43,5.21,0,2.26,1.45,4,4.46,4.63l5.73,1.1c7.46,1.45,11.46,6.31,11.46,12.1,0,6.31-5.27,12.67-14.82,12.67-10.88,0-15.68-7-16.32-12.84l7.41-2c.35,4,3.18,7.7,9,7.7,4.28,0,6.66-2.15,6.66-5,0-2.37-1.8-4.23-5-4.86l-5.73-1.16c-6.54-1.33-10.77-5.56-10.77-11.75,0-7.29,6.54-12.85,14.3-12.85,9.95,0,13.77,6,14.7,10.65Z",
    transform: "translate(-46.1 -33.61)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M511.72,78.81c-1.56,2.66-4.86,3.82-7.87,3.82-6.89,0-10.82-5-10.82-11.23v-18h7.69V69.84c0,3.18,1.62,5.73,5.21,5.73,3.42,0,5.38-2.32,5.38-5.62V53.4H519V76.72a48.61,48.61,0,0,0,.29,5.16H512A20.28,20.28,0,0,1,511.72,78.81Z",
    transform: "translate(-46.1 -33.61)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M532.55,72.5c.18,2.26,1.86,4.34,5.21,4.34,2.55,0,3.76-1.33,3.76-2.84,0-1.27-.86-2.31-3.06-2.77l-3.76-.87c-5.5-1.22-8-4.52-8-8.51,0-5.09,4.51-9.32,10.65-9.32,8.1,0,10.82,5.15,11.17,8.22L542.1,62.2a4.33,4.33,0,0,0-4.68-3.82c-2,0-3.65,1.21-3.65,2.83,0,1.39,1,2.26,2.6,2.55l4,.87c5.62,1.16,8.46,4.57,8.46,8.74,0,4.63-3.59,9.37-11.06,9.37-8.57,0-11.52-5.55-11.86-8.79Z",
    transform: "translate(-46.1 -33.61)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M565.72,53.4h5.73v6.83h-5.73V72.15c0,2.49,1.15,3.3,3.35,3.3a11,11,0,0,0,2.38-.23v6.37a11.48,11.48,0,0,1-4.34.69c-5.56,0-9-3.3-9-8.8V60.23h-5.15V53.4h1.44c3,0,4.4-2,4.4-4.51v-4h7Z",
    transform: "translate(-46.1 -33.61)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M586.09,65.5l7-1c1.62-.23,2.14-1,2.14-2,0-2-1.56-3.7-4.8-3.7s-5.21,2.14-5.44,4.62l-6.83-1.44c.46-4.46,4.57-9.38,12.21-9.38,9,0,12.38,5.1,12.38,10.82v14a32.49,32.49,0,0,0,.35,4.52H596a19.76,19.76,0,0,1-.29-3.42,9.51,9.51,0,0,1-8.39,4.23c-6.08,0-9.78-4.11-9.78-8.57C577.58,69,581.34,66.19,586.09,65.5Zm9.14,4.86V69.08l-6.42,1c-2,.29-3.53,1.39-3.53,3.59,0,1.68,1.21,3.3,3.7,3.3C592.22,77,595.23,75.39,595.23,70.36Z",
    transform: "translate(-46.1 -33.61)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M615.49,39.28a4.75,4.75,0,1,1-4.75,4.8A4.74,4.74,0,0,1,615.49,39.28Zm-3.82,42.6V53.4h7.69V81.88Z",
    transform: "translate(-46.1 -33.61)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M636.44,81.88h-7.7V53.4h7.47v3.53a9.45,9.45,0,0,1,8.21-4.28c7.07,0,10.31,5,10.31,11.28V81.88H647V65.27c0-3.19-1.56-5.68-5.27-5.68-3.35,0-5.32,2.61-5.32,5.91Z",
    transform: "translate(-46.1 -33.61)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M670.47,65.5l7-1c1.62-.23,2.14-1,2.14-2,0-2-1.56-3.7-4.8-3.7s-5.21,2.14-5.44,4.62l-6.83-1.44c.46-4.46,4.57-9.38,12.21-9.38,9,0,12.39,5.1,12.39,10.82v14a32.65,32.65,0,0,0,.34,4.52h-7.06a19.76,19.76,0,0,1-.29-3.42,9.49,9.49,0,0,1-8.39,4.23c-6.08,0-9.78-4.11-9.78-8.57C662,69,665.72,66.19,670.47,65.5Zm9.14,4.86V69.08l-6.42,1c-2,.29-3.53,1.39-3.53,3.59,0,1.68,1.21,3.3,3.7,3.3C676.6,77,679.61,75.39,679.61,70.36Z",
    transform: "translate(-46.1 -33.61)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M696.05,81.88V40h7.58V56.53c1.27-2,4.4-3.88,8.62-3.88,8.34,0,13.14,6.42,13.14,14.87,0,8.63-5.32,15-13.43,15-3.93,0-6.94-1.74-8.45-4.17v3.48Zm14.58-22.34c-3.88,0-7.12,2.83-7.12,8s3.24,8.1,7.12,8.1,7.06-2.89,7.06-8.1S714.57,59.54,710.63,59.54Z",
    transform: "translate(-46.1 -33.61)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M732.62,81.88V40h7.7V81.88Z",
    transform: "translate(-46.1 -33.61)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M775.22,73.71c-1.45,4.92-6,9-13,9-7.82,0-14.7-5.61-14.7-15.22,0-9.08,6.71-15,14-15,8.8,0,14.07,5.62,14.07,14.76,0,1.1-.12,2.26-.12,2.37H755.14a6.93,6.93,0,0,0,7.17,6.49c3.59,0,5.56-1.8,6.49-4.34ZM768,64.4c-.11-2.84-2-5.62-6.36-5.62a6.16,6.16,0,0,0-6.37,5.62Z",
    transform: "translate(-46.1 -33.61)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M185.89,98c8,0,12.5,4.69,12.5,11.05a9.12,9.12,0,0,1-6,8.8,9.7,9.7,0,0,1,7.23,9.73c0,6.65-5,11.46-12.67,11.46H171.13V98Zm-1.22,17c3.65,0,5.85-2,5.85-5.15s-2-5.1-5.9-5.1H179V115Zm.81,17.42c3.88,0,6.2-2,6.2-5.33s-2.09-5.49-6.08-5.49H179v10.82Z",
    transform: "translate(-46.1 -33.61)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M225,136c-1.57,2.66-4.87,3.82-7.88,3.82-6.88,0-10.82-5-10.82-11.23v-18H214V127c0,3.18,1.62,5.73,5.21,5.73,3.41,0,5.38-2.32,5.38-5.62V110.55h7.7v23.32a46,46,0,0,0,.29,5.16h-7.35A19,19,0,0,1,225,136Z",
    transform: "translate(-46.1 -33.61)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M245.79,129.65c.17,2.26,1.85,4.34,5.21,4.34,2.54,0,3.76-1.33,3.76-2.84,0-1.27-.87-2.31-3.07-2.77l-3.76-.87c-5.5-1.22-8-4.52-8-8.51,0-5.09,4.52-9.32,10.65-9.32,8.11,0,10.83,5.15,11.17,8.22l-6.42,1.45a4.34,4.34,0,0,0-4.69-3.82c-2,0-3.65,1.21-3.65,2.83,0,1.39,1.05,2.26,2.61,2.55l4,.87c5.61,1.16,8.45,4.57,8.45,8.74,0,4.63-3.59,9.37-11.05,9.37-8.57,0-11.52-5.55-11.87-8.79Z",
    transform: "translate(-46.1 -33.61)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M273.28,96.43a4.75,4.75,0,1,1-4.75,4.8A4.75,4.75,0,0,1,273.28,96.43ZM269.46,139V110.55h7.7V139Z",
    transform: "translate(-46.1 -33.61)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M294.23,139h-7.7V110.55H294v3.53a9.45,9.45,0,0,1,8.22-4.28c7.06,0,10.3,5,10.3,11.28v18h-7.7V122.42c0-3.19-1.56-5.68-5.27-5.68-3.35,0-5.32,2.61-5.32,5.91Z",
    transform: "translate(-46.1 -33.61)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M347,130.87c-1.44,4.91-6,9-13,9-7.82,0-14.7-5.61-14.7-15.22,0-9.09,6.71-15,14-15,8.8,0,14.07,5.62,14.07,14.76,0,1.1-.12,2.26-.12,2.37H326.93a6.94,6.94,0,0,0,7.18,6.49,6.3,6.3,0,0,0,6.48-4.34Zm-7.17-9.32c-.12-2.84-2-5.62-6.37-5.62a6.17,6.17,0,0,0-6.37,5.62Z",
    transform: "translate(-46.1 -33.61)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M358.82,129.65c.17,2.26,1.85,4.34,5.21,4.34,2.54,0,3.76-1.33,3.76-2.84,0-1.27-.87-2.31-3.07-2.77l-3.76-.87c-5.5-1.22-8-4.52-8-8.51,0-5.09,4.52-9.32,10.65-9.32,8.1,0,10.82,5.15,11.17,8.22l-6.42,1.45a4.34,4.34,0,0,0-4.69-3.82c-2,0-3.65,1.21-3.65,2.83,0,1.39,1.05,2.26,2.61,2.55l4.05.87c5.61,1.16,8.45,4.57,8.45,8.74,0,4.63-3.59,9.37-11.06,9.37-8.56,0-11.51-5.55-11.86-8.79Z",
    transform: "translate(-46.1 -33.61)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M386.66,129.65c.17,2.26,1.85,4.34,5.2,4.34,2.55,0,3.77-1.33,3.77-2.84,0-1.27-.87-2.31-3.07-2.77l-3.76-.87c-5.5-1.22-8-4.52-8-8.51,0-5.09,4.51-9.32,10.65-9.32,8.1,0,10.82,5.15,11.17,8.22l-6.42,1.45a4.35,4.35,0,0,0-4.69-3.82c-2,0-3.65,1.21-3.65,2.83,0,1.39,1,2.26,2.61,2.55l4,.87c5.61,1.16,8.45,4.57,8.45,8.74,0,4.63-3.59,9.37-11.06,9.37-8.56,0-11.52-5.55-11.86-8.79Z",
    transform: "translate(-46.1 -33.61)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M453,139l-18.64-29.12V139h-8V98h9.95l17.08,27.14V98h8v41Z",
    transform: "translate(-46.1 -33.61)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M496.68,130.87c-1.45,4.91-6,9-13,9-7.81,0-14.7-5.61-14.7-15.22,0-9.09,6.71-15,14-15,8.79,0,14.06,5.62,14.06,14.76,0,1.1-.12,2.26-.12,2.37H476.59a6.94,6.94,0,0,0,7.18,6.49c3.59,0,5.56-1.8,6.48-4.34Zm-7.18-9.32c-.12-2.84-2-5.62-6.37-5.62a6.16,6.16,0,0,0-6.36,5.62Z",
    transform: "translate(-46.1 -33.61)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M513.81,110.55h5.73v6.83h-5.73V129.3c0,2.49,1.15,3.3,3.35,3.3a11,11,0,0,0,2.38-.23v6.37a11.48,11.48,0,0,1-4.34.69c-5.56,0-9-3.3-9-8.8V117.38H501v-6.83h1.44c3,0,4.4-2,4.4-4.51v-4h6.95Z",
    transform: "translate(-46.1 -33.61)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M551.54,110.55l6.13,18.35,5.27-18.35h7.64L561.67,139H554l-6.65-19.45L540.78,139H533l-9.08-28.48H532l5.27,18.29,6.19-18.29Z",
    transform: "translate(-46.1 -33.61)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M603.51,124.79c0,8.74-6.42,15.1-14.93,15.1s-14.93-6.36-14.93-15.1,6.42-15.11,14.93-15.11S603.51,116,603.51,124.79Zm-7.7,0c0-5.38-3.47-8.11-7.23-8.11s-7.24,2.73-7.24,8.11,3.48,8.1,7.24,8.1S595.81,130.17,595.81,124.79Z",
    transform: "translate(-46.1 -33.61)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M628.11,118.19a11.87,11.87,0,0,0-2.32-.23c-3.93,0-7.35,1.91-7.35,8v13h-7.69V110.55h7.46v4.23c1.74-3.77,5.67-4.46,8.1-4.46.64,0,1.22.06,1.8.11Z",
    transform: "translate(-46.1 -33.61)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M650.91,122.53,662.54,139h-9.43l-7.52-10.89-3.19,3.36V139h-7.69V97.12h7.69v24l9.84-10.59h10.07Z",
    transform: "translate(-46.1 -33.61)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsbclogo);
export default __webpack_public_path__ + "static/media/asbclogo.adad6847cb96abcadcc080cc2435fdb8.svg";
export { ForwardRef as ReactComponent };